<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="md:mt-32 mt-24 mx-auto">
      <div
        class="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 space-y-8 text-gray-700 leading-relaxed"
      >
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">
          Privacy Policy
        </h2>
        <p class="text-lg">
          We respect your privacy and are committed to protecting your personal
          information when you use our e-commerce platform.
        </p>

        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Information We Collect
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>Personal details such as name, email, and phone number</li>
            <li>Shipping and billing addresses</li>
            <li>Order history and transaction details</li>
          </ul>
        </div>

        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            How We Use Your Information
          </h3>
          <p>
            Your data is used to process orders, improve our services, and
            communicate important updates related to your account and purchases.
          </p>
        </div>

        <p class="text-sm text-gray-500 pt-4 border-t">
          Last updated: January 2026
        </p>
      </div>
    </div>
  </div>
</div>
